import { Component, Input, ContentChild, TemplateRef } from "@angular/core";

@Component({
  selector: "sv-block-header",
  templateUrl: "./block-header.component.html",
  styleUrls: ["./block-header.component.scss"],
})
export class BlockHeaderComponent {
  @Input() title: string = "";
  @Input() modifier: string = "";
  @Input() showForms: boolean = false;
  @Input() isHeaderFirst: boolean = true;

  // Content projection for tools section
  @ContentChild("toolsTemplate") toolsTemplate: TemplateRef<any> | null = null;

  // Content projection for content section
  @ContentChild("contentTemplate") contentTemplate: TemplateRef<any> | null = null;
  
  // Content projection for forms section
  @ContentChild("formsTemplate") formsTemplate: TemplateRef<any> | null = null;

  // Content projection for title section
  @ContentChild("titleTemplate") titleTemplate: TemplateRef<any> | null = null;

  constructor() {}
}
